import React from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { SortableTreeWithoutDndContext } from '@nosferatu500/react-sortable-tree';

// react-dnd 14 + React 18 StrictMode 조합에서 전역 DnD 컨텍스트가 초기화되어
// 'Cannot have two HTML5 backends at the same time' 오류가 발생하므로 window 컨텍스트를 명시해 재사용
const DndSortableTree = (props) => (
	<DndProvider backend={HTML5Backend} context={window}>
		<SortableTreeWithoutDndContext {...props} />
	</DndProvider>
);

export default DndSortableTree;
